import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppUpdateService } from 'app/services/app-update.service';

@Component({
    selector: 'app-update-banner',
    imports: [AsyncPipe, TranslateModule],
    templateUrl: './app-update-banner.component.html',
    styleUrl: './app-update-banner.component.scss',
})
export class AppUpdateBannerComponent {
    readonly updateAvailable$ = this._appUpdateService.updateAvailable$;
    reloading = false;

    constructor(private readonly _appUpdateService: AppUpdateService) {}

    reloadNow(): void {
        if (this.reloading) {
            return;
        }

        this.reloading = true;
        void this._appUpdateService.reloadNow().then((reloaded) => {
            if (!reloaded) {
                this.reloading = false;
            }
        });
    }

    snooze(): void {
        this._appUpdateService.snoozeUpdate();
    }
}
